import { Injectable, inject } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { of } from 'rxjs';
import * as InstagramActions from '../actions/instagram.action';
import { switchMap, map, catchError } from 'rxjs/operators';
import { InstagramService } from '../../services';

@Injectable()
export class InstagramEffects {
  private actions$ = inject(Actions);
  private service = inject(InstagramService);

  LoadPosts$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(InstagramActions.LoadInstaPosts),
      switchMap(() =>
        this.service.getInstaPosts().pipe(
          map(instaPosts => InstagramActions.LoadInstaPostsSuccess({ instaPosts })),
          catchError(error => of(InstagramActions.LoadInstaPostsFail({ error })))
        )
      )
    );
  });
}
